define('lib/multivariate-testing/allocation-strategies/random',['require','exports','module','lodash','jquery'],function (require, exports, module) {
    var _ = require('lodash');
    var $ = require('jquery');

    /**
     * Selects a variation ID at random.
     *
     * @param {array} variation - Possible variations for a particular test.
     * @returns {Promise}
     */
    module.exports = function (variations) {
        var allocating = $.Deferred();

        allocating.resolve(_.sample(variations).id);
        return allocating.promise();
    };
});

